// extracted by mini-css-extract-plugin
export default {"container":"eo-z","bubbleNav":"fo-z","graphic":"go-z","contact":"ho-z"};